import script from "./OtrosView.vue?vue&type=script&setup=true&lang=js"
export * from "./OtrosView.vue?vue&type=script&setup=true&lang=js"

import "./OtrosView.vue?vue&type=style&index=0&id=2b10d359&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b10d359"]])

export default __exports__